import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { generateTimeOptions } from '../utils/slots';

interface TimeRangeFieldsProps {
  startTime: string;
  endTime: string;
  onStartChange: (value: string) => void;
  onEndChange: (value: string) => void;
  sameDay: boolean;
  idPrefix?: string;
}

export function TimeRangeFields({
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  sameDay,
  idPrefix = 'time',
}: TimeRangeFieldsProps) {
  const options = useMemo(() => generateTimeOptions(), []);
  const startLabelId = `${idPrefix}-start-label`;
  const endLabelId = `${idPrefix}-end-label`;

  const endOptions = useMemo(() => {
    if (!sameDay || !startTime) return options;
    return options.filter((t) => t > startTime);
  }, [options, sameDay, startTime]);

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <FormControl fullWidth required>
        <InputLabel id={startLabelId}>Ora inizio</InputLabel>
        <Select
          labelId={startLabelId}
          label="Ora inizio"
          value={startTime}
          onChange={(e) => onStartChange(e.target.value)}
        >
          {options.slice(0, -1).map((t) => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth required>
        <InputLabel id={endLabelId}>Ora fine</InputLabel>
        <Select
          labelId={endLabelId}
          label="Ora fine"
          value={endTime}
          onChange={(e) => onEndChange(e.target.value)}
        >
          {endOptions.map((t) => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}
